import { Link, useParams } from "react-router-dom";

const services = {
  "wealth-management": { title: "Wealth Management", tag: "Flagship", desc: "Multi-asset portfolios for families and HNIs.", details: ["Personalised Investment Policy Statement","Asset allocation across equity, debt, gold and alternates","Quarterly rebalancing and written reviews","Estate and succession coordination"] },
  "mutual-fund-advisory": { title: "Mutual Fund Advisory", tag: "Direct plans", desc: "Goal-mapped MF portfolios, direct plans only.", details: ["Direct plan implementation","Goal-based tagging","Tax harvesting","Consolidated CAS reports"] },
  "financial-planning": { title: "Financial Planning", tag: "Written plan", desc: "A blueprint for your money life.", details: ["Cashflow and budgeting","Insurance audit","Retirement corpus planning","Children's education & marriage goals"] },
  "corporate-advisory": { title: "Corporate Advisory", tag: "For founders", desc: "Treasury, structuring and capital raise support.", details: ["Company treasury management","Cap table & ESOP structuring","Founder personal finance","Debt syndication support"] },
  "trading-brokerage": { title: "Trading & Brokerage", tag: "Execution", desc: "Disciplined execution with research backing.", details: ["Broker-neutral execution","Risk & margin discipline","Systematic strategies","Access to institutional research"] },
  "market-research": { title: "Market Research", tag: "Unbiased", desc: "Independent research notes and theses.", details: ["Sector deep-dives","Company-level notes","Macro & thematic views","No brokerage tie-ups"] },
  "compliance": { title: "Compliance", tag: "Advisory", desc: "Regulatory advisory for HNIs and corporates.", details: ["FEMA & LRS advisory","Tax reporting support","Trust deeds & structuring","AIF/PMS due diligence"] },
};

export function ServicesIndex() {
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
      <div className="overline text-gold-dark mb-6">Practices</div>
      <h1 className="font-display text-5xl md:text-6xl text-midnight tracking-tight mb-14">What we do, <span className="italic">carefully</span>.</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {Object.entries(services).map(([slug, s]) => (
          <Link key={slug} to={`/services/${slug}`} data-testid={`services-index-${slug}`} className="group p-8 bg-white rounded-2xl border border-black/5 hover:border-gold/40 transition-colors">
            <div className="overline text-gold-dark mb-3">{s.tag}</div>
            <h3 className="font-display text-2xl text-midnight mb-3">{s.title}</h3>
            <p className="text-sm text-midnight/70 leading-relaxed">{s.desc}</p>
            <div className="mt-6 text-sm font-semibold text-midnight group-hover:text-gold-dark">Learn more →</div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export function ServiceDetail() {
  const { slug } = useParams();
  const s = services[slug];
  if (!s) return <div className="p-20 text-center text-midnight/60">Service not found. <Link to="/services" className="text-gold-dark underline">Back</Link></div>;
  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-10 py-20">
      <Link to="/services" className="text-sm text-midnight/60 hover:text-midnight">← All services</Link>
      <div className="overline text-gold-dark mt-8 mb-4">{s.tag}</div>
      <h1 className="font-display text-5xl md:text-6xl text-midnight tracking-tight">{s.title}</h1>
      <p className="mt-6 text-lg text-midnight/70 max-w-2xl leading-relaxed">{s.desc}</p>
      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
        {s.details.map((d, i) => (
          <div key={i} className="p-6 bg-white rounded-xl border border-black/5">
            <div className="font-display text-lg text-midnight mb-2">0{i+1}</div>
            <p className="text-sm text-midnight/75 leading-relaxed">{d}</p>
          </div>
        ))}
      </div>
      <div className="mt-14"><Link to="/book" data-testid="service-book-btn" className="btn-gold">Speak to an advisor</Link></div>
    </div>
  );
}
